export const deploymentMessage = {
  title: 'New Version Available',
  message: `<p>A new version of this application has been deployed to improve functionality, security, and stability.
            To continue using the app, it is necessary to update now.</p>
            <p>By clicking <strong>OK</strong>, the page will refresh automatically to apply the update.</p>`,
  buttonText: 'OK',
  isInnerHtml: true,
};

export interface updateMessage {
  title: string;
  message: string;
  buttonText: string;
  isInnerHtml: boolean;
}
